import { render, staticRenderFns } from "./ebook-products.vue?vue&type=template&id=48058c65&"
import script from "./ebook-products.vue?vue&type=script&lang=js&"
export * from "./ebook-products.vue?vue&type=script&lang=js&"
import style0 from "./ebook-products.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports